import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MediaComponent } from '@shared/components/media/media.component';
import { ScreenViewModule } from '@core/directives/screen-view/_screen-view.module';
import { Link } from '@core/models/atomics.model';
import { DEVICE_SIZE } from '@core/models/deviceSize.model';
import { CX_ABSTRACT_COMPONENT_DATA } from '@b2b/components/cms/cx-abstract/cx-abstract.tokens';
import { AbstractLinesComponent } from '@b2b/components/cms/sections/cx-header-section/components/header-mobile/abstract-lines/abstract-lines.component';
import { LinkComponent } from '@shared/components/link/link.component';

@Component({
  selector: 'cx-main-navigation-bar',
  templateUrl: './cx-main-navigation-bar.component.html',
  styleUrls: ['./cx-main-navigation-bar.component.scss'],
  imports: [CommonModule, RouterModule, ScreenViewModule, AbstractLinesComponent, MediaComponent, LinkComponent],
})
export class CxMainNavigationBarComponent {
  protected DEVICE_SIZE = DEVICE_SIZE;
  protected data = inject<{ items: Link[] }>(CX_ABSTRACT_COMPONENT_DATA);
}
